/*
 * Filename: d:\projects\AutoFiFront\src\Theme\CarInfoIcon.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Tuesday, February 14th 2023, 11:57:19 am
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */
import styled from "styled-components";

const CarInfoIcon = styled.div.attrs(props => ({
    bgColor: props.bgColor,
}))`
margin-right: 0.3rem;
padding-left: -1rem;
min-width: 1rem;
color: ${props => props.bgColor == "CITYCAR" ? props.theme.colors.second : props.bgColor == "SUV" ? props.theme.colors.third : props.bgColor == "UTILITY" ? props.theme.colors.fourth : props.bgColor == "SEDAN" ? props.theme.colors.fifth : props.bgColor == "BREAK" ? props.theme.colors.sixth : props.theme.colors.first};
`;

export default CarInfoIcon;
